import { Typography } from 'jpi-cloud-web-ui-kit';
import styled, { createGlobalStyle, css } from 'styled-components';
import { NotificationType } from './types';

export const NotificationOverrides = createGlobalStyle`
  .Toastify__toast-container {
    top: 20px !important;
    width: auto !important;
  }

  .Toastify__toast {
    background: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 0 16px !important;
    min-height: 0 !important;
    width: auto !important;
    border-radius: 0 !important;
  }

  .Toastify__toast-body {
    display: block !important;
    flex: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .Toastify__toast-icon,
  .Toastify__close-button,
  .Toastify__progress-bar--wrp {
    display: none !important;
  }

  .legacy-notification-toast--success {
    background: #008d5a !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    color: white !important;
    padding: 15px 20px !important;
    width: 533px !important;
  }

  .legacy-notification-toast--warning {
    background: #eeab46 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    color: black !important;
    padding: 15px 20px !important;
    width: 533px !important;
  }
`;

export const MainContainer = styled(Typography)<{ type: NotificationType }>`
  &&& {
    padding: 15px;
    padding-left: 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    width: 533px;
    height: auto;
    position: relative;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    ${({ type, theme }) => {
      const backgroundColors: Record<NotificationType, string> = {
        success: theme.COLORS.background.success,
        warning: theme.COLORS.background.warning,
        error: theme.COLORS.background.error,
        info: theme.COLORS.info,
        default: theme.COLORS.info,
      };
      return css`
        background-color: color-mix(in srgb, ${backgroundColors[type]} 80%, transparent);
      `;
    }}
  }
`;

export const CloseButton = styled(Typography)`
  &&& {
    position: absolute;
    top: 15px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-weight: bold;
    color: ${({ theme }) => theme.COLORS.white};
  }
`;

export const Title = styled(Typography)<{ color: string }>`
  margin-bottom: 15px;
  font-size: 15px;
  display: flex;
  gap: 8px;
  color: ${({ color }) => color};
  align-items: center;
  font-weight: bold;
`;

export const Description = styled(Typography)<{ color: string }>`
  &&& {
    margin-top: 10px;
    width: 90%;
    color: ${({ color }) => color};
    word-break: break-word;
    hyphens: auto;
  }
`;

export const MoreDetails = styled(Typography)<{ color: string }>`
  &&& {
    font-weight: bold;
    cursor: pointer;
    color: ${({ color }) => color};
    display: inline-block;
    margin-top: 15px;
  }
`;
